export default __webpack_public_path__ + "static/media/marker_active.ab40b42f.svg";